export class HeaderMenuItem {
  public readonly label: string;
  public readonly redirectTo: string;

  constructor({ label, redirectTo }: { label: string; redirectTo: string }) {
    this.label = label.toUpperCase();
    this.redirectTo = redirectTo;
  }
}
